module.exports = __webpack_public_path__ + "img/verified-card-button.dd09eef.png";